
export const POST_DESIGN = "POST_DESIGN";
export const GET_DESIGNS = "GET_DESIGNS";
export const DELETE_DESIGN = "DELETE_DESIGN";
export const UPDATE_DESIGN = "UPDATE_DESIGN" 
export const CLEAR_MESSAGE = "CLEAR_MESSAGE" 


